import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_ITEMS } from "../../mock/mockData";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 bg-[#F4F0E8] border-b-[3px] border-black ${
        scrolled ? "shadow-[0_4px_0_0_#0A0A0A]" : ""
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 group">
          <div className="w-10 h-10 bg-black flex items-center justify-center brut-btn">
            <span className="text-[#FFD60A] display font-bold text-xl leading-none">V</span>
          </div>
          <div className="flex flex-col leading-none">
            <span className="display font-bold text-[15px] md:text-[17px] tracking-tight">VEENTTO</span>
            <span className="mono text-[9px] md:text-[10px] uppercase text-black/70 tracking-widest">B2B / 2026</span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="group px-3 py-2 mono text-[12px] uppercase font-medium tracking-wide hover:bg-black hover:text-[#FFD60A] transition-colors"
            >
              <span className="text-black/40 group-hover:text-[#E63946] mr-1">{item.num}</span>
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#candidatura"
          className="hidden md:inline-flex items-center bg-[#E63946] text-white font-bold mono text-[12px] uppercase tracking-wider px-5 py-3 brut-border brut-btn"
        >
          Candidatar-me →
        </a>

        <button
          aria-label={open ? "Fechar menu" : "Abrir menu"}
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen(!open)}
          className="lg:hidden w-11 h-11 brut-border flex items-center justify-center bg-white brut-btn"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div id="mobile-navigation" className="lg:hidden border-t-[3px] border-black bg-[#F4F0E8]">
          <div className="px-5 py-4 grid gap-2">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 px-4 py-3 brut-border bg-white mono text-[13px] uppercase font-medium"
              >
                <span className="text-[#E63946] font-bold">{item.num}</span>
                {item.label}
              </a>
            ))}
            <a
              href="#candidatura"
              onClick={() => setOpen(false)}
              className="mt-2 text-center bg-[#E63946] text-white font-bold mono text-[13px] uppercase tracking-wider px-5 py-4 brut-border"
            >
              Candidatar-me →
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
